import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { Button } from '@framework/ui/atoms/Button';
import { usePrevious } from '@view-model/models/common/hooks/usePrevious';

type Props = {
  isOpen: boolean;
  type: 'thread' | 'comment';
  onConfirm(): void;
  onClose(): void;
};

export const ModelCommentDeleteConfirmModal = ({ isOpen, type, onConfirm, onClose }: Props) => {
  const { t } = useTranslation();
  const previousIsOpen = usePrevious(isOpen);
  const [checked, setChecked] = useState(false);

  // モーダルを開いた時にチェック状態をリセット
  useEffect(() => {
    if (isOpen && !previousIsOpen) {
      setChecked(false);
    }
  }, [isOpen, previousIsOpen]);

  const prefix = type === 'thread' ? 'canvas.comment.deleteThread' : 'canvas.comment.deleteComment';

  const handleClose = useCallback(() => {
    setChecked(false);
    onClose();
  }, [onClose]);

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={handleClose}
      shouldCloseOnOverlayClick={false}
      title={t(`${prefix}.title`)}
      submitButton={
        <Button color="danger" onClick={onConfirm} disabled={!checked}>
          {t('common.action.delete')}
        </Button>
      }
      cancelButton={
        <Button color="secondary" onClick={handleClose}>
          {t('common.action.cancel')}
        </Button>
      }
    >
      <div className="w-[400px] p-4">
        {type === 'thread' ? (
          <div className="pb-4">
            <p>{t('canvas.comment.deleteThread.description1')}</p>
            <p>{t('canvas.comment.deleteThread.description2')}</p>
          </div>
        ) : (
          <p className="pb-4">{t('canvas.comment.deleteComment.description')}</p>
        )}
        <label className="block">
          <input
            type="checkbox"
            className="form-checkbox mr-1 size-6 border-brand"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          {t(`${prefix}.checkLabel`)}
        </label>
      </div>
    </GeneralModal>
  );
};
